export default {
    mapGeofenceDeleteGeofenceGroup_title:'Delete Geofence Groups',
    mapGeofenceDeleteGeofenceGroup_move: 'Move to',
    mapGeofenceDeleteGeofenceGroup_deleteAll: 'Delete (All geofences in those groups are removed)',
    mapGeofenceDeleteGeofenceGroup_success: "Geofence Groups deleted",
    mapGeofenceDeleteGeofenceGroup_question1: 'What do you want to do with geofences in those landmark groups?',
    mapGeofenceDeleteGeofenceGroup_deleteAction: 'Available Actions',
    mapGeofenceDeleteGeofenceGroup_question2: 'Are you sure you want to delete those geofences groups?',
    mapGeofenceDeleteGeofenceGroup_warning: 'Delete actions cannot be undone.',
}